import RestartLocaleEN from '../domains/restart/locales/en';
import CommonLocaleEN from '../domains/common/locales/en';

export default {
  restart: RestartLocaleEN,
  common: CommonLocaleEN,
};
